var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.showDeleteRedundantPhotoOnServer,
        width: "1180px",
        "custom-class": "modern-dialog",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        "show-close": false,
        top: "4vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showDeleteRedundantPhotoOnServer = $event
        },
        open: _vm.handleOpen,
      },
    },
    [
      _c("div", { staticClass: "dialog-header-themed" }, [
        _c("div", { staticClass: "themed-left" }, [
          _c("div", { staticClass: "themed-icon warning-icon" }, [
            _c("i", { staticClass: "el-icon-brush" }),
          ]),
          _c("div", { staticClass: "themed-text" }, [
            _c("div", { staticClass: "title-row" }, [
              _c("h3", [_vm._v("CHỌN TRƯỜNG DỌN DẸP ẢNH THỪA TRÊN HỆ THỐNG")]),
            ]),
            _c("p", [
              _vm._v(
                "Quét và giải phóng các tệp ảnh rác hoặc không còn tham chiếu trong cơ sở dữ liệu của các trường được chọn"
              ),
            ]),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "themed-close",
            on: { click: _vm.closeDialogByButton },
          },
          [_c("i", { staticClass: "el-icon-close" })]
        ),
      ]),
      _c("div", { staticClass: "modern-dialog-content" }, [
        _c("div", { staticClass: "form-section" }, [
          _c("h4", { staticClass: "section-divider" }, [
            _c("i", { staticClass: "el-icon-search" }),
            _vm._v(" BỘ LỌC TÌM KIẾM TRƯỜNG"),
          ]),
          _c(
            "div",
            { staticClass: "filter-row" },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "180px" },
                  attrs: {
                    size: "small",
                    placeholder: "Trạng thái kích hoạt",
                    clearable: "",
                  },
                  on: { change: _vm.searchHeaderMethod },
                  model: {
                    value: _vm.dataSearch.active,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "active", $$v)
                    },
                    expression: "dataSearch.active",
                  },
                },
                _vm._l(_vm.statusAccountList, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { value: item.key, label: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "170px" },
                  attrs: {
                    size: "small",
                    placeholder: "Trạng thái xóa",
                    clearable: "",
                  },
                  on: { change: _vm.searchHeaderMethod },
                  model: {
                    value: _vm.dataSearch.deleteStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "deleteStatus", $$v)
                    },
                    expression: "dataSearch.deleteStatus",
                  },
                },
                _vm._l(_vm.deleteList, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { value: item.key, label: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-input",
                {
                  staticStyle: { width: "280px" },
                  attrs: {
                    size: "small",
                    placeholder: "Nhập tên trường học...",
                    clearable: "",
                  },
                  on: { clear: _vm.searchHeaderMethod },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchHeaderMethod.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.dataSearch.nameSchool,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "nameSchool", $$v)
                    },
                    expression: "dataSearch.nameSchool",
                  },
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: { click: _vm.searchHeaderMethod },
                    slot: "append",
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "form-section" }, [
          _c("h4", { staticClass: "section-divider" }, [
            _c("i", { staticClass: "el-icon-files" }),
            _vm._v(" DANH SÁCH TRƯỜNG CẦN DỌN DẸP"),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingDataDelete,
                  expression: "loadingDataDelete",
                },
              ],
              staticClass: "transfer-wrapper",
              attrs: { "element-loading-text": "Đang tải danh sách trường..." },
            },
            [
              _c("el-transfer", {
                attrs: {
                  filterable: "",
                  "filter-placeholder": "Tìm trường trong danh sách...",
                  titles: [
                    `Tất cả trường (${_vm.dataSource.length})`,
                    `Trường được dọn dẹp (${_vm.dataTarget.length})`,
                  ],
                  "button-texts": ["Bỏ chọn", "Chọn dọn"],
                  data: _vm.dataSource,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ option }) {
                      return _c("span", {}, [_vm._v(_vm._s(option.label))])
                    },
                  },
                ]),
                model: {
                  value: _vm.dataTarget,
                  callback: function ($$v) {
                    _vm.dataTarget = $$v
                  },
                  expression: "dataTarget",
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "form-section" }, [
          _c("h4", { staticClass: "section-divider" }, [
            _c("i", { staticClass: "el-icon-date" }),
            _vm._v(" THIẾT LẬP THỜI GIAN & ĐIỀU KIỆN DỌN DẸP"),
          ]),
          _c("div", { staticClass: "config-grid" }, [
            _c(
              "div",
              { staticClass: "config-item" },
              [
                _c("span", { staticClass: "config-label" }, [
                  _c("i", { staticClass: "el-icon-date" }),
                  _vm._v(" Năm áp dụng "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(":"),
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "140px" },
                    attrs: { size: "small", placeholder: "Chọn năm" },
                    model: {
                      value: _vm.years,
                      callback: function ($$v) {
                        _vm.years = $$v
                      },
                      expression: "years",
                    },
                  },
                  _vm._l(_vm.listYears, function (item) {
                    return _c("el-option", {
                      key: item,
                      attrs: { value: item, label: item },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "config-item" },
              [
                _c("span", { staticClass: "config-label" }, [
                  _c("i", { staticClass: "el-icon-time" }),
                  _vm._v(" Các tháng áp dụng "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  _vm._v(":"),
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "260px" },
                    attrs: {
                      size: "small",
                      placeholder: "Chọn các tháng",
                      multiple: "",
                      "collapse-tags": "",
                    },
                    model: {
                      value: _vm.months,
                      callback: function ($$v) {
                        _vm.months = $$v
                      },
                      expression: "months",
                    },
                  },
                  _vm._l(_vm.listMonth, function (item) {
                    return _c("el-option", {
                      key: item.key,
                      attrs: { value: item.key, label: item.label },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "config-item-check" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.checkExitServer,
                      callback: function ($$v) {
                        _vm.checkExitServer = $$v
                      },
                      expression: "checkExitServer",
                    },
                  },
                  [
                    _c("span", { staticClass: "checkbox-text" }, [
                      _c("i", { staticClass: "el-icon-coin" }),
                      _vm._v(
                        " Kiểm tra đối chiếu ảnh thừa với cơ sở dữ liệu trước khi xóa\n            "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "dialog-footer-themed" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "medium" },
              on: { click: _vm.closeDialogByButton },
            },
            [_c("i", { staticClass: "el-icon-close" }), _vm._v(" Đóng\n    ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "gradient-btn purple-btn",
              attrs: {
                size: "medium",
                icon: "el-icon-brush",
                disabled: _vm.dataTarget.length === 0,
                loading: _vm.loadingButton,
              },
              on: { click: _vm.deleteRedundantPhotos },
            },
            [
              _vm._v(
                "\n      Tiến hành dọn ảnh thừa (" +
                  _vm._s(_vm.dataTarget.length) +
                  " trường)\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }